import { Button, Dialog, Divider } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import LocalSeeIcon from '@mui/icons-material/LocalSee';
import AddIcon from '@mui/icons-material/Add';
import axios from "axios";
import baseURL from "../../configs/api";
import useAuth from "../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { getCommentsReportByAttributeAndAttributeId, put_comment } from "../../services/comment";
import Webcam from "react-webcam";
import { handleCapture } from "../../utils/covertTheBase64FormatIntoImage";
import { delete_fileUpload, put_fileUpload } from "../../services/appFileUpload";
import { branchTimezone } from "../../utils/summaryCalculation";
import useConfirm from "../hooks/useConfirm";
import { useTheme } from "../hooks/useTheme";
import colorConfigs from "../../configs/colorConfigs";
import { CustomImagePopup } from "./CustomImagePopup";
import { getReservation } from "../../services/reservation";
import { getVehicleReplaceId } from "../../services/VehicleReplcae";
import { updateFilesAndCommentsApi } from "../../services/rental";
import Cookies from "js-cookie";
import useTenant from "../hooks/useTenant";
import moment from "moment";
import useGeneral from "../hooks/useGeneral";

type EditReplaceVehicleModalProps = {
    editReplaceVehicleIsOpen: boolean;
    setEditReplaceVehicleIsOpen: (value: boolean) => void;
    refreshTheSummary: (value: boolean) => void;
    replacementModalData: any;
    reservationId: number;
    locationOptions: any[];
    checkOutFiles: any[];
    checkInFiles: any[];
    vehicleReplacementCheckOutFiles: any[];
    vehicleReplacementCheckInFiles: any[];
    formattedCreatedAt: string;
    refreshTheAttachement: () => void;
    isCompletedOrCancelled: boolean;
    setPleaseWaitPopup: (value: boolean) => void;
}

const EditReplaceVehicleModal = ({
    editReplaceVehicleIsOpen,
    setEditReplaceVehicleIsOpen,
    replacementModalData,
    reservationId,
    locationOptions,
    checkOutFiles,
    checkInFiles,
    vehicleReplacementCheckOutFiles,
    vehicleReplacementCheckInFiles,
    formattedCreatedAt,
    refreshTheAttachement,
    isCompletedOrCancelled,
    setPleaseWaitPopup
}: EditReplaceVehicleModalProps) => {
    const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
    const { theme, themeStyles } = useTheme();
    const { dateFormat }: any = useGeneral();
    const navigate = useNavigate();
    const { auth }: any = useAuth();
    const { handleTenantError }: any = useTenant();
    const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
    const [isContinue, setIsContinue] = useState<boolean>(false);
    const [replacedVehicleLink, setReplacedVehicleLink] = useState<string>("");
    const [pickupLocation, setPickupLocation] = useState<string>("");
    const [fuelLevelAtPickup, setFuelLevelAtPickup] = useState<string>("");
    const [odometerAtPickup, setOdometerAtPickup] = useState<string>("");
    const [pickupDate, setIsPickupDate] = useState<string>("");
    const [pickupTime, setPickupTime] = useState<string>("");
    const [returnLocation, setReturnLocation] = useState<string>("");
    const [fuelLevelAtReturn, setFuelLevelAtReturn] = useState<string>("");
    const [ChargeFuelToClient, setChargeFuelToClient] = useState<string>("");
    const [odometerAtReturn, setOdometerAtReturn] = useState<string>("");
    const [returnDate, setReturnDate] = useState<string>("");
    const [returnTime, setReturnTime] = useState<string>("");
    const [replacementVehicle, setReplacementVehicle] = useState<string>("");
    const [freeChange, setFreeChange] = useState<string>("");
    const [currentOdometer, setCurrentOdometer] = useState<string>("");
    const [newVehicleFuelLevel, setNewVehicelFuelLevel] = useState<string>("");
    const [replacementComment, setReplacementComment] = useState<string>("");
    const [vehicleId, setVehicleId] = useState<number>(0);

    const returnInputFileRef = useRef<HTMLInputElement>(null);
    const newInputFileRef = useRef<HTMLInputElement>(null);

    const [pickupVehicleFilePath, setPickupVehicleFilePath] = useState<any[]>([]);
    const [pickupVehiclefileIndex, setPickupVehiclefileIndex] = useState<number>(-1);
    const [imagePopup, setImagePopup] = useState<boolean>(false);
    const [returnVehicleFilePath, setReturnVehicleFilePath] = useState<any[]>([]);
    const [returnVehiclefileIndex, setReturnVehiclefileIndex] = useState<number>(-1);
    const [returnVehicleNewFilePath, setReturnVehicleNewFilePath] = useState<any[]>([]);
    const [NewVehicleNewFilePath, setNewVehicleNewFilePath] = useState<any[]>([]);
    const [newVehicleFilePath, setNewVehicleFilePath] = useState<any[]>([]);
    const [newVehicleId, setNewVehicleId] = useState<number>(0);

    const [commentValue, setCommentValue] = useState<any | null>(null);


    const [newVehicleFileIndex, setNewVehicleFileIndex] = useState<number>(-1);
    const [currentPreview, setCurrrentPreview] = useState<string>("");
    const webRef = useRef(null);
    const [currentWebCam, setCurrrentWebCam] = useState<string>("");
    const [showWebcam, setShowWebcam] = useState<boolean>(false);

    const UpdateTimezone = branchTimezone(formattedCreatedAt);
    const closeIconFill = theme === "dark" ? "fill-[#E4E7EC]" : "fill-[#1D2939]";

    useEffect(() => {
        if (replacementModalData && locationOptions?.length > 0 && editReplaceVehicleIsOpen) {
            setPleaseWaitPopup(true);

            setReplacedVehicleLink(replacementModalData?.replacedVehicle);
            setReplacementVehicle(replacementModalData?.replacementVehicle);
            setReplacementComment(replacementModalData?.replacementComments);

            //Replaced Vehicle data 
            if (replacementModalData?.replacedId === reservationId) {
                if (replacementModalData?.replacedId) {
                    getReservation(replacementModalData?.replacedId, tenantId)
                        .then(data => {
                            setVehicleId(data?.vehicleId);
                            const pickupLocation = locationOptions?.find((item: any) => item?.id === data?.pickupLoationId);
                            if (pickupLocation) {
                                setPickupLocation(pickupLocation?.locationName);
                            }

                            setFuelLevelAtPickup(data?.fuelLevelAtCheckOut)
                            setOdometerAtPickup(data?.odometerAtCheckOut)

                            if (data?.dateTimeCheckOut) {
                                setIsPickupDate(moment(new Date(data?.dateTimeCheckOut)).format(dateFormat));
                                setPickupTime(moment(new Date(data?.dateTimeCheckOut)).format("hh:mm a"));
                            }

                            const returnLocation = locationOptions?.find((item: any) => item?.id === data?.returenLoationId);
                            if (returnLocation) {
                                setReturnLocation(returnLocation?.locationName);
                            }

                            setFuelLevelAtReturn(data?.fuelLevelAtCheckIn);
                            setChargeFuelToClient(data?.chargeFuleToClient === true ? "Yes" : "No");
                            setOdometerAtReturn(data?.odometerAtCheckIn);

                            if (data?.dateTimeCheckIn) {
                                setReturnDate(moment(new Date(data?.dateTimeCheckIn)).format(dateFormat));
                                setReturnTime(moment(new Date(data?.dateTimeCheckIn)).format("hh:mm a"));
                            }
                            setPleaseWaitPopup(false);
                            handleTenantError(null);
                        })
                        .catch(error => {
                            setPleaseWaitPopup(false);
                            handleTenantError(error);
                        })
                }
            } else {
                if (replacementModalData?.replacedId) {
                    getVehicleReplaceId(replacementModalData?.replacedId, tenantId)
                        .then(data => {
                            setVehicleId(data?.vehicleId);
                            const pickupLocation = locationOptions?.find((item: any) => item?.id === data?.pickupLoationId);
                            if (pickupLocation) {
                                setPickupLocation(pickupLocation?.locationName);
                            }

                            setFuelLevelAtPickup(data?.fuelLevelAtCheckOut)
                            setOdometerAtPickup(data?.odometerAtCheckOut)

                            if (data?.dateTimeCheckOut) {
                                setIsPickupDate(moment(new Date(data?.dateTimeCheckOut)).format(dateFormat));
                                setPickupTime(moment(new Date(data?.dateTimeCheckOut)).format("hh:mm a"));
                            }

                            const returnLocation = locationOptions?.find((item: any) => item?.id === data?.returenLoationId);
                            if (returnLocation) {
                                setReturnLocation(returnLocation?.locationName);
                            }

                            setFuelLevelAtReturn(data?.fuelLevelAtCheckIn);
                            setChargeFuelToClient(data?.chargeFuleToClient === true ? "Yes" : "No");
                            setOdometerAtReturn(data?.odometerAtCheckIn);

                            if (data?.dateTimeCheckIn) {
                                setReturnDate(moment(new Date(data?.dateTimeCheckIn)).format(dateFormat));
                                setReturnTime(moment(new Date(data?.dateTimeCheckIn)).format("hh:mm a"));
                            }

                            setPleaseWaitPopup(false);
                            handleTenantError(null);
                        })
                        .catch(error => {
                            setPleaseWaitPopup(false);
                            handleTenantError(error);
                        })
                }
            }

            //Replacement Vehicle data 
            if (replacementModalData?.id) {
                getVehicleReplaceId(replacementModalData?.id, tenantId)
                    .then(data => {
                        setNewVehicleId(data?.vehicleId);
                        setFreeChange(data?.isFreeChange === true ? "Yes" : "No")
                        setCurrentOdometer(data?.odometerAtCheckOut);
                        setNewVehicelFuelLevel(data?.fuelLevelAtCheckOut ?? "");

                        setPleaseWaitPopup(false);
                        handleTenantError(null);
                    })
                    .catch(error => {
                        setPleaseWaitPopup(false);
                        handleTenantError(error);
                    })
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [replacementModalData, locationOptions, editReplaceVehicleIsOpen])

    useEffect(() => {
        if (editReplaceVehicleIsOpen) {
            if (replacementModalData?.replacedId === reservationId) {
                setPickupVehicleFilePath(
                    checkInFiles?.map((item: any) => ({
                        id: item.id,
                        fileName: `${baseURL}reservationFile/Get?name=${item.fileName}`
                    }))
                );

                setReturnVehicleFilePath(
                    checkInFiles?.map((item: any) => ({
                        id: item.id,
                        fileName: `${baseURL}reservationFile/Get?name=${item.fileName}`
                    }))
                );


                const replacedCheckoutOldFiles = vehicleReplacementCheckOutFiles?.filter((item: any) =>
                    parseInt(item?.tabName?.replace("Checkout-VehicleReplacement-", "")) === replacementModalData?.id
                );

                setNewVehicleFilePath(
                    replacedCheckoutOldFiles?.map((item: any) => ({
                        id: item.id,
                        fileName: `${baseURL}reservationFile/Get?name=${item.fileName}`
                    }))
                );
            } else {
                const checkoutOldFiles = vehicleReplacementCheckOutFiles?.filter((item: any) =>
                    parseInt(item?.tabName?.replace("Checkout-VehicleReplacement-", "")) === replacementModalData?.replacedId
                );

                setPickupVehicleFilePath(
                    checkoutOldFiles?.map((item: any) => ({
                        id: item.id,
                        fileName: `${baseURL}reservationFile/Get?name=${item.fileName}`
                    }))
                );

                const checkinOldFiles = vehicleReplacementCheckInFiles?.filter((item: any) =>
                    parseInt(item?.tabName?.replace("Checkin-VehicleReplacement-", "")) === replacementModalData?.replacedId
                );

                setReturnVehicleFilePath(
                    checkinOldFiles?.map((item: any) => ({
                        id: item.id,
                        fileName: `${baseURL}reservationFile/Get?name=${item.fileName}`
                    }))
                );

                const replacedCheckoutOldFiles = vehicleReplacementCheckOutFiles?.filter((item: any) =>
                    parseInt(item?.tabName?.replace("Checkout-VehicleReplacement-", "")) === replacementModalData?.id
                );

                setNewVehicleFilePath(
                    replacedCheckoutOldFiles?.map((item: any) => ({
                        id: item.id,
                        fileName: `${baseURL}reservationFile/Get?name=${item.fileName}`
                    }))
                );
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkInFiles, checkOutFiles, vehicleReplacementCheckOutFiles, replacementModalData, editReplaceVehicleIsOpen])


    useEffect(() => {
        if (replacementModalData && editReplaceVehicleIsOpen) {
            getCommentsReportByAttributeAndAttributeId('VehicleReplacement', replacementModalData?.id, tenantId)
                .then((res) => {
                    if (res?.length > 0) {
                        setCommentValue(res[0]);
                    }
                    handleTenantError(null);
                })
                .catch(error => {
                    setPleaseWaitPopup(false);
                    handleTenantError(error);
                });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [replacementModalData, editReplaceVehicleIsOpen])


    const onReturnVehicleFileChangeCapture = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPleaseWaitPopup(true);
        const selectedFiles = e.target.files as FileList;

        if (selectedFiles.length !== 0) {
            const formData = new FormData();
            formData.append("ImageFile", selectedFiles[0]);

            axios
                .post(`${baseURL}reservationFile/upload`, formData, {
                    headers: {
                        'X-Tenant-ID': tenantId,
                        "Content-Type": "multipart/form-data"
                    },
                    withCredentials: true,
                })
                .then((response) => {
                    const newFilePath: any = {
                        id: 0,
                        fileName:
                            `${baseURL}reservationFile/Get?name=` +
                            response.data,
                    };

                    setReturnVehicleNewFilePath((prevPath: string[]) => [
                        ...prevPath,
                        newFilePath.fileName,
                    ]);
                    setReturnVehicleFilePath((prevPath: any[]) => [...prevPath, newFilePath]);
                    setPleaseWaitPopup(false);
                    handleTenantError(null);
                })
                .catch((error) => {
                    handleTenantError(error);
                });
        } else {
            setPleaseWaitPopup(false);
        }
    };

    const onNewVehicleFileChangeCapture = (e: React.ChangeEvent<HTMLInputElement>) => {
        setPleaseWaitPopup(true);
        const selectedFiles = e.target.files as FileList;

        if (selectedFiles.length !== 0) {
            const formData = new FormData();
            formData.append("ImageFile", selectedFiles[0]);

            axios
                .post(`${baseURL}reservationFile/upload`, formData, {
                    headers: {
                        'X-Tenant-ID': tenantId,
                        "Content-Type": "multipart/form-data"
                    },
                    withCredentials: true,
                })
                .then((response) => {
                    const newFilePath: any = {
                        id: 0,
                        fileName:
                            `${baseURL}reservationFile/Get?name=` +
                            response.data,
                    };

                    setNewVehicleNewFilePath((prevPath: string[]) => [
                        ...prevPath,
                        newFilePath.fileName,
                    ]);
                    setNewVehicleFilePath((prevPath: any[]) => [...prevPath, newFilePath]);
                    setPleaseWaitPopup(false);
                    handleTenantError(null);
                })
                .catch((error) => {
                    handleTenantError(error);
                });
        } else {
            setPleaseWaitPopup(false);
        }
    };

    const updateFile = (e: React.ChangeEvent<HTMLInputElement>, id: number) => {
        setPleaseWaitPopup(true);

        const selectedFiles = e.target.files as FileList;
        if (selectedFiles.length !== 0) {
            const formData = new FormData();
            formData.append("ImageFile", selectedFiles[0]);
            axios
                .post(`${baseURL}reservationFile/upload`, formData, {
                    headers: {
                        'X-Tenant-ID': tenantId,
                        "Content-Type": "multipart/form-data"
                    },
                    withCredentials: true,
                })
                .then((response) => {
                    if (replacementModalData?.replacedId === reservationId) {
                        put_fileUpload({
                            id,
                            attributeName: "Reservation",
                            attributeId: reservationId,
                            fileName: response.data,
                            tabName: currentPreview === 'return-vehicle' ? "Checkin" : `Checkout-VehicleReplacement-${replacementModalData?.id}`,
                            userId: auth?.id ?? 0,
                            createdDate: new Date(UpdateTimezone).toLocaleString()
                        }, auth?.id, tenantId)
                            .then(() => {
                                if (currentPreview === 'return-vehicle') {
                                    setReturnVehicleFilePath((prevPath: any[]) =>
                                        prevPath.map(file =>
                                            file.id === id ? {
                                                ...file, fileName: `${baseURL}reservationFile/Get?name=` +
                                                    response.data,
                                            } : file
                                        )
                                    );
                                } else if (currentPreview === 'pickup-vehicle') {
                                    setPickupVehicleFilePath((prevPath: any[]) =>
                                        prevPath.map(file =>
                                            file.id === id ? {
                                                ...file, fileName: `${baseURL}reservationFile/Get?name=` +
                                                    response.data,
                                            } : file
                                        )
                                    );
                                } else {
                                    setNewVehicleFilePath((prevPath: any[]) =>
                                        prevPath.map(file =>
                                            file.id === id ? {
                                                ...file, fileName: `${baseURL}reservationFile/Get?name=` +
                                                    response.data,
                                            } : file
                                        )
                                    );
                                }

                                setPleaseWaitPopup(false);
                                refreshTheAttachement();
                                handleTenantError(null);
                            })
                            .catch((error) => {
                                const errorMessage = error?.response?.data?.message || error?.message || "File upload failed.";
                                setConfirmData({
                                    title: 'Warning',
                                    summary: errorMessage,
                                    confirmBtn: 'Ok',
                                    isConfirm: (callback: any) => {
                                        callback();
                                    }
                                });
                                setConfirmPopup(true);
                                setPleaseWaitPopup(false);
                                handleTenantError(error);
                            })
                    } else {
                        put_fileUpload({
                            id,
                            attributeName: "Reservation",
                            attributeId: reservationId,
                            fileName: response.data,
                            tabName: currentPreview === 'return-vehicle' ? `Checkin-VehicleReplacement-${replacementModalData?.replacedId}` : `Checkout-VehicleReplacement-${replacementModalData?.id}`,
                            userId: auth?.id ?? 0,
                            createdDate: new Date(UpdateTimezone).toLocaleString()
                        }, auth?.id, tenantId)
                            .then(() => {
                                if (currentPreview === 'return-vehicle') {
                                    setReturnVehicleFilePath((prevPath: any[]) =>
                                        prevPath.map(file =>
                                            file.id === id ? {
                                                ...file, fileName: `${baseURL}reservationFile/Get?name=` +
                                                    response.data,
                                            } : file
                                        )
                                    );
                                } else if (currentPreview === 'pickup-vehicle') {
                                    setPickupVehicleFilePath((prevPath: any[]) =>
                                        prevPath.map(file =>
                                            file.id === id ? {
                                                ...file, fileName: `${baseURL}reservationFile/Get?name=` +
                                                    response.data,
                                            } : file
                                        )
                                    );
                                } else {
                                    setNewVehicleFilePath((prevPath: any[]) =>
                                        prevPath.map(file =>
                                            file.id === id ? {
                                                ...file, fileName: `${baseURL}reservationFile/Get?name=` +
                                                    response.data,
                                            } : file
                                        )
                                    );
                                }

                                setPleaseWaitPopup(false);
                                refreshTheAttachement();
                                handleTenantError(null);
                            })
                            .catch((error) => {
                                const errorMessage = error?.response?.data?.message || error?.message || "File upload failed.";
                                setConfirmData({
                                    title: 'Warning',
                                    summary: errorMessage,
                                    confirmBtn: 'Ok',
                                    isConfirm: (callback: any) => {
                                        callback();
                                    }
                                });
                                setConfirmPopup(true);
                                setPleaseWaitPopup(false);
                                handleTenantError(error);
                            })
                    }
                    handleTenantError(null);
                })
                .catch((error) => {
                    setPleaseWaitPopup(false);
                    handleTenantError(error);
                });
        } else {
            setPleaseWaitPopup(false);
        }
    }

    const showWarningMessageOnNoImage = () => {
        let summary = 'Are you sure you want to continue without image?';

        if (returnVehicleFilePath?.length <= 0) {
            summary += ' - Replace Vehicle Check In Image';
        }

        if (newVehicleFilePath?.length <= 0) {
            summary += ' - Replacement Vehicle Check Out Image';
        }

        setConfirmData({
            title: 'Confirm for Vehicle Replacement',
            summary: summary,
            confirmBtn: 'Continue without image',
            isConfirm: (callback: any) => {
                setIsContinue(true);
                editReplacedTheVehicle();
                callback();
            }
        });

        setConfirmPopup(true);
    }

    const handleSubmit = () => {
        if (!isCompletedOrCancelled) {
            if (!isContinue && (returnVehicleFilePath?.length <= 0 || newVehicleFilePath?.length <= 0)) {
                showWarningMessageOnNoImage();
                return;
            }

            editReplacedTheVehicle();
        }
    }

    const editReplacedTheVehicle = () => {
        setPleaseWaitPopup(true);
        let files: any[] = [];

        if (returnVehicleNewFilePath?.filter((item: any) => item.id === 0)?.length > 0) {
            returnVehicleNewFilePath
                ?.filter((item: any) => item.id === 0)
                ?.forEach((item: string, index) => {
                    files.push({
                        attributeName: "Reservation",
                        attributeId: reservationId,
                        fileName: item?.replace(`${baseURL}reservationFile/Get?name=`, ""),
                        tabName: replacementModalData?.replacedId === reservationId ? "Checkin" : `Checkin-VehicleReplacement-${replacementModalData?.id}`,
                        userId: auth?.id ?? 0,
                        createdDate: new Date(UpdateTimezone).toLocaleString()
                    });

                    if (returnVehicleNewFilePath?.length - 1 === index) {
                        updateNewReplacementFile(files)
                    }
                });
        } else {
            updateNewReplacementFile(files)
        }
    }

    const updateNewReplacementFile = (files: any[]) => {
        if (NewVehicleNewFilePath?.filter((item: any) => item.id === 0)?.length > 0) {
            NewVehicleNewFilePath
                ?.filter((item: any) => item.id === 0)
                ?.forEach((item: string, index: number) => {
                    files.push({
                        attributeName: "Reservation",
                        attributeId: reservationId,
                        fileName: item?.replace(`${baseURL}reservationFile/Get?name=`, ""),
                        tabName: `Checkout-VehicleReplacement-${replacementModalData?.id}`,
                        userId: auth?.id ?? 0,
                        createdDate: new Date(UpdateTimezone).toLocaleString()
                    });

                    if (NewVehicleNewFilePath?.length - 1 === index) {
                        updateTheComment(files)
                    }
                });
        } else {
            updateTheComment(files)
        }
    }

    const updateTheComment = (files: any[]) => {
        let comments: any[] = [];
        if (commentValue) {
            put_comment({
                attributeName: "VehicleReplacement",
                attributeId: replacementModalData?.id,
                notes: replacementComment?.trim(),
                id: commentValue?.id,
                userId: auth?.id,
                createdDate: new Date(UpdateTimezone).toLocaleString()
            }, auth?.id, tenantId)
                .then(() => {
                    updateFilesAndComments(files, comments);
                    handleTenantError(null);
                })
                .catch(error => {
                    setPleaseWaitPopup(false);
                    handleTenantError(error);
                });
        } else {
            if (replacementComment?.trim() !== "") {
                comments.push({
                    attributeName: "VehicleReplacement",
                    attributeId: replacementModalData?.id,
                    notes: replacementComment?.trim(),
                    userId: auth?.id,
                    createdDate: new Date(UpdateTimezone).toLocaleString()
                });

                updateFilesAndComments(files, comments);
            }
        }
    }

    const updateFilesAndComments = (files: any[], comments: any[]) => {
        updateFilesAndCommentsApi(
            {
                fileUploadDatas: files,
                comments: comments
            },
            reservationId,
            auth?.id,
            tenantId
        )
            .then(() => {
                setPleaseWaitPopup(false);
                setEditReplaceVehicleIsOpen(false);
                setReturnVehicleFilePath([]);
                setNewVehicleFilePath([]);
                refreshTheAttachement();
                setCommentValue(null);
                handleTenantError(null);
            })
            .catch(error => {
                setPleaseWaitPopup(false);
                handleTenantError(error);
            });
    }


    return (
        <>
            <Dialog
                open={editReplaceVehicleIsOpen}
                maxWidth="md"
                fullScreen={false}
                sx={{
                    '& .MuiDialog-paper': {
                        maxWidth: '650px',
                        width: '100%',
                        borderRadius: '16px',
                    },
                }}
            >
                <div className={`px-[15px] py-[15px] h-full ${themeStyles.main.tailwindSectionBg}`}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 320.591 320.591"
                        className={`w-3 cursor-pointer float-right ${closeIconFill}`}
                        onClick={() => setEditReplaceVehicleIsOpen(false)}
                    >
                        <path d="M30.391 318.583a30.37 30.37 0 0 1-21.56-7.288c-11.774-11.844-11.774-30.973 0-42.817L266.643 10.665c12.246-11.459 31.462-10.822 42.921 1.424 10.362 11.074 10.966 28.095 1.414 39.875L51.647 311.295a30.366 30.366 0 0 1-21.256 7.288z" />
                        <path d="M287.9 318.583a30.37 30.37 0 0 1-21.257-8.806L8.83 51.963C-2.078 39.225-.595 20.055 12.143 9.146c11.369-9.736 28.136-9.736 39.504 0l259.331 257.813c12.243 11.462 12.876 30.679 1.414 42.922-.456.487-.927.958-1.414 1.414a30.368 30.368 0 0 1-23.078 7.288z" />
                    </svg>
                    <div className={`w-full bg-transparent rounded-lg p-[10px] flex flex-col gap-2.51`}>
                        <div className="w-full mt-2">
                            <div className={`w-full`}>
                                <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                                    <div className="flex items-center gap-1.5">
                                        <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Edit Vehicle Replacement</h2>
                                    </div>
                                </div>

                                <div className="mt-2 p-2">
                                    <div className="w-full">
                                        <div>
                                            <span className={`text-[14px] font-semibold inline-block mb-2 ${themeStyles.main.textHeadingColor}`}>
                                                Pickup Information
                                            </span>

                                            <Divider className={`w-full ${themeStyles.divider.bg}`} />

                                            <div className="grid grid-cols-2 gap-6">
                                                <div>
                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Vehicle Link</label>
                                                        <br />
                                                        <span
                                                            className={`text-xs font-medium underline text-[#0000ff] cursor-pointer`}
                                                            onClick={() =>
                                                                navigate("/fleet/vehicle/editvehicles", {
                                                                    state: vehicleId,
                                                                })
                                                            }
                                                        >
                                                            {replacedVehicleLink}
                                                        </span>
                                                    </div>

                                                    <div className="mt-[27px]">
                                                        <label className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Fuel level at Pickup</label>
                                                        <br />
                                                        <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{`${fuelLevelAtPickup} / 8`}</span>
                                                    </div>

                                                    <div className="mt-[21px]">
                                                        <label className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Pickup Date</label>
                                                        <br />
                                                        <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{pickupDate}</span>
                                                    </div>
                                                </div>

                                                <div className="space-y-4">
                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Pickup Location</label>
                                                        <br />
                                                        <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{pickupLocation}</span>
                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Odometer at Pickup</label>
                                                        <br />
                                                        <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{odometerAtPickup}</span>
                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Pickup Time</label>
                                                        <br />
                                                        <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{pickupTime}</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="mt-4 mb-2 w-full">
                                                <label className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Images</label>
                                                <div className="max-w-1/2 flex flex-row items-center gap-[5px] flex-wrap">
                                                    {
                                                        pickupVehicleFilePath?.map((item: any, outerIndex: number) => (
                                                            <React.Fragment key={outerIndex}>
                                                                <img
                                                                    src={item.fileName}
                                                                    width={40}
                                                                    height={40}
                                                                    alt="vehicle"
                                                                    onClick={() => {
                                                                        setPickupVehiclefileIndex(outerIndex);
                                                                        setImagePopup(true);
                                                                        setCurrrentPreview('pickup-vehicle')
                                                                    }}
                                                                />

                                                            </React.Fragment>
                                                        ))
                                                    }
                                                </div>
                                            </div>

                                            <span className={`text-[14px] font-semibold inline-block mb-2 ${themeStyles.main.textHeadingColor}`}>
                                                Return Information
                                            </span>

                                            <Divider className={`w-full ${themeStyles.divider.bg}`} />

                                            <div className="grid grid-cols-2 gap-6">
                                                <div>
                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Vehicle Link</label>
                                                        <br />
                                                        <span
                                                            className={`text-xs font-medium hover:underline text-[#0000ff] cursor-pointer`}
                                                            onClick={() =>
                                                                navigate("/fleet/vehicle/editvehicles", {
                                                                    state: vehicleId,
                                                                })
                                                            }
                                                        >
                                                            {replacedVehicleLink}
                                                        </span>
                                                    </div>

                                                    <div className="mt-[19px]">
                                                        <div className="flex gap-x-[0.5rem]">
                                                            <div>
                                                                <label className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Fuel level at Return</label>
                                                                <br />
                                                                <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{`${fuelLevelAtReturn} / 8`}</span>
                                                            </div>

                                                            <div>
                                                                <label className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Charge fuel to client?</label>
                                                                <br />
                                                                <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{ChargeFuelToClient}</span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="mt-[19px]">
                                                        <label className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Return Date</label>
                                                        <br />
                                                        <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{returnDate}</span>
                                                    </div>
                                                </div>

                                                <div className="space-y-4">
                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Return Location</label>
                                                        <br />
                                                        <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{returnLocation}</span>
                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Odometer at Return</label>
                                                        <br />
                                                        <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{odometerAtReturn}</span>
                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Return Time</label>
                                                        <br />
                                                        <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{returnTime}</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="mt-4 mb-2 w-full">
                                                <div className="max-w-1/2 flex flex-row items-center gap-[5px] flex-wrap">
                                                    {
                                                        returnVehicleFilePath?.map((item: any, outerIndex: number) => (
                                                            <React.Fragment key={outerIndex}>
                                                                <img
                                                                    src={item.fileName}
                                                                    width={40}
                                                                    height={40}
                                                                    alt="repairOrder"
                                                                    onClick={() => {
                                                                        setReturnVehiclefileIndex(outerIndex);
                                                                        setImagePopup(true);
                                                                        setCurrrentPreview('return-vehicle')
                                                                    }}
                                                                />
                                                                <RemoveCircleIcon
                                                                    className={`text-[14px] ${themeStyles.main.textSubHeadingColor} font-bold  hover:text-red-500 cursor-pointer`}
                                                                    onClick={() => {
                                                                        setConfirmData({
                                                                            title: 'Delete image',
                                                                            summary: "Are you sure you want to delete this image?",
                                                                            confirmBtn: 'Yes',
                                                                            isConfirm: async (callback: any) => {
                                                                                let newFileSet: any[] = returnVehicleFilePath?.filter(
                                                                                    (_, index: number) => index !== outerIndex
                                                                                );

                                                                                if (returnVehicleFilePath[outerIndex].id === 0) {
                                                                                    setReturnVehicleFilePath(() => newFileSet);
                                                                                } else {
                                                                                    setPleaseWaitPopup(true);

                                                                                    delete_fileUpload(returnVehicleFilePath[outerIndex]?.id, auth?.id, tenantId)
                                                                                        .then(() => {
                                                                                            setReturnVehicleFilePath(() => newFileSet);
                                                                                            setPleaseWaitPopup(false);
                                                                                            refreshTheAttachement();
                                                                                            handleTenantError(null);
                                                                                        })
                                                                                        .catch((error) => {
                                                                                            setPleaseWaitPopup(false);
                                                                                            handleTenantError(error);
                                                                                        });
                                                                                }
                                                                                callback();
                                                                            }
                                                                        });
                                                                        setConfirmPopup(true);
                                                                    }}
                                                                />
                                                            </React.Fragment>
                                                        ))
                                                    }
                                                </div>

                                                <div>
                                                    <label className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Images</label>
                                                    <input
                                                        type="file"
                                                        name="inputFileRef"
                                                        accept="image/*"
                                                        ref={returnInputFileRef}
                                                        onChangeCapture={onReturnVehicleFileChangeCapture}
                                                        style={{ display: "none" }}
                                                    />
                                                    <div className="flex flex-row gap-2 mt-2">
                                                        <p
                                                            className="border border-dashed border-black rounded px-2 py-[3px] flex justify-center items-center text-[12px] bg-white cursor-pointer"
                                                            onClick={() => {
                                                                if (returnInputFileRef.current) {
                                                                    returnInputFileRef.current.value = "";
                                                                }

                                                                returnInputFileRef.current?.click();
                                                            }}
                                                        >
                                                            <AddIcon className="text-[#167AC3] text-[14px] font-bold" />
                                                            Add Image
                                                        </p>

                                                        <p
                                                            className="border border-dashed border-black rounded px-2 py-[3px] flex justify-center items-center text-[12px] bg-white cursor-pointer"
                                                            onClick={() => {
                                                                setShowWebcam(true)
                                                                setCurrrentWebCam('return-vehicle')
                                                            }}
                                                        >
                                                            <LocalSeeIcon className="text-[#167AC3] text-[14px] font-bold" />
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="mt-4">
                                                <span className={`text-[14px] font-semibold inline-block mb-2 ${themeStyles.main.textHeadingColor}`}>
                                                    Vehicle Replacement
                                                </span>

                                                <Divider className={`w-full ${themeStyles.divider.bg}`} />

                                                <div className="grid grid-cols-2 gap-6">
                                                    <div className="space-y-4">
                                                        <div>
                                                            <label className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Replacement Vehicle</label>
                                                            <br />
                                                            <span
                                                                className={`text-xs font-medium hover:underline text-[#0000ff] cursor-pointer`}
                                                                onClick={() =>
                                                                    navigate("/fleet/vehicle/editvehicles", {
                                                                        state: newVehicleId,
                                                                    })
                                                                }
                                                            >
                                                                {replacementVehicle}
                                                            </span>
                                                        </div>

                                                        <div>
                                                            <label className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Current Odomemeter</label>
                                                            <br />
                                                            <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{currentOdometer}</span>
                                                        </div>
                                                    </div>

                                                    <div className="space-y-4">
                                                        <div>
                                                            <label className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Free Change?</label>
                                                            <br />
                                                            <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{freeChange}</span>
                                                        </div>

                                                        <div>
                                                            <label className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Fuel Level</label>
                                                            <br />
                                                            <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>{`${newVehicleFuelLevel} / 8`}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="mt-4 mb-2 w-full">
                                                    <div className="max-w-1/2 flex flex-row items-center gap-[5px] flex-wrap">
                                                        {
                                                            newVehicleFilePath?.map((item: any, outerIndex: number) => (
                                                                <React.Fragment key={outerIndex}>
                                                                    <img
                                                                        src={item.fileName}
                                                                        width={40}
                                                                        height={40}
                                                                        alt="vehilce"
                                                                        onClick={() => {
                                                                            setNewVehicleFileIndex(outerIndex);
                                                                            setImagePopup(true);
                                                                            setCurrrentPreview('new-vehicle')
                                                                        }}
                                                                    />
                                                                    <RemoveCircleIcon
                                                                        className={`text-[14px] ${themeStyles.main.textSubHeadingColor} font-bold  hover:text-red-500 cursor-pointer`}
                                                                        onClick={() => {
                                                                            setConfirmData({
                                                                                title: 'Delete image',
                                                                                summary: "Are you sure you want to delete this image?",
                                                                                confirmBtn: 'Yes',
                                                                                isConfirm: async (callback: any) => {
                                                                                    let newFileSet: any[] = newVehicleFilePath?.filter(
                                                                                        (_, index: number) => index !== outerIndex
                                                                                    );

                                                                                    if (newVehicleFilePath[outerIndex].id === 0) {
                                                                                        setNewVehicleFilePath(() => newFileSet);
                                                                                    } else {
                                                                                        setPleaseWaitPopup(true);

                                                                                        delete_fileUpload(newVehicleFilePath[outerIndex]?.id, auth?.id, tenantId)
                                                                                            .then(() => {
                                                                                                setNewVehicleFilePath(() => newFileSet);
                                                                                                setPleaseWaitPopup(false);
                                                                                                refreshTheAttachement();
                                                                                                handleTenantError(null);
                                                                                            })
                                                                                            .catch((error) => {
                                                                                                setPleaseWaitPopup(false);
                                                                                                handleTenantError(error);
                                                                                            });
                                                                                    }
                                                                                    callback();
                                                                                }
                                                                            });
                                                                            setConfirmPopup(true);

                                                                        }}
                                                                    />
                                                                </React.Fragment>
                                                            ))
                                                        }
                                                    </div>

                                                    <div>
                                                        <label className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Images</label>
                                                        <input
                                                            type="file"
                                                            name="inputFileRef"
                                                            accept="image/*"
                                                            ref={newInputFileRef}
                                                            onChangeCapture={onNewVehicleFileChangeCapture}
                                                            style={{ display: "none" }}
                                                        />
                                                        <div className="flex flex-row gap-2 mt-2">
                                                            <p
                                                                className="border border-dashed border-black rounded px-2 py-[3px] flex justify-center items-center text-[12px] bg-white cursor-pointer"
                                                                onClick={(e) => {
                                                                    if (newInputFileRef.current) {
                                                                        newInputFileRef.current.value = "";
                                                                    }

                                                                    newInputFileRef.current?.click();
                                                                }}
                                                            >
                                                                <AddIcon className="text-[#167AC3] text-[14px] font-bold" />
                                                                Add Image
                                                            </p>

                                                            <p
                                                                className="border border-dashed border-black rounded px-2 py-[3px] flex justify-center items-center text-[12px] bg-white cursor-pointer"
                                                                onClick={() => {
                                                                    setShowWebcam(true)
                                                                    setCurrrentWebCam('new-vehicle')
                                                                }}
                                                            >
                                                                <LocalSeeIcon className="text-[#167AC3] text-[14px] font-bold" />
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="w-full mt-4">
                                                    <label className={`text-xs font-medium ${themeStyles.main.textHeadingColor}`}>Comments</label>
                                                    <textarea
                                                        className={`w-full px-[8px] py-[8px]  border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                                        rows={4}
                                                        onChange={(e) => setReplacementComment(e.target.value)}
                                                        value={replacementComment}
                                                        required
                                                    />
                                                </div>

                                                <div className="mt-4 w-full flex gap-4">
                                                    <Button variant="contained"
                                                        sx={{
                                                            backgroundColor: colorConfigs.btn.main.bg
                                                        }}
                                                        onClick={() => handleSubmit()}
                                                    >
                                                        Save
                                                    </Button>

                                                    <Button variant="contained"
                                                        sx={{
                                                            backgroundColor: colorConfigs.btn.cancel.bg,
                                                            border: colorConfigs.btn.cancel.border,
                                                            color: colorConfigs.btn.cancel.color
                                                        }}
                                                        onClick={() => setEditReplaceVehicleIsOpen(false)}
                                                    >
                                                        Cancel
                                                    </Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>

            <Dialog
                open={showWebcam}
                maxWidth="md"
                fullScreen={false}
                sx={{
                    '& .MuiDialog-paper': {
                        maxWidth: '500px',
                        width: '100%',
                        borderRadius: '16px',
                    },
                }}
            >
                <div className={`px-[10px] py-[5px] h-full ${themeStyles.main.tailwindSectionBg}`}>
                    <div className={`w-full bg-transparent rounded-lg p-[10px] flex flex-col gap-2.51`}>
                        <div className="w-full mt-2">
                            <div className={`w-full`}>
                                <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                                    <div className="flex items-center gap-1.5">
                                        <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>WebCam</h2>
                                    </div>
                                </div>

                                <div className="mt-2 p-2">
                                    <div className="w-full">
                                        <Webcam
                                            width={480}
                                            height={320}
                                            ref={webRef}
                                            screenshotFormat="image/png"
                                            audio={false}
                                        />

                                        <div className="flex gap-4 mt-6">
                                            <Button variant="contained"
                                                sx={{
                                                    backgroundColor: colorConfigs.btn.cancel.bg,
                                                    border: colorConfigs.btn.cancel.border,
                                                    color: colorConfigs.btn.cancel.color
                                                }}
                                                onClick={() => setShowWebcam(false)}>
                                                Cancel
                                            </Button>

                                            <Button variant="contained"
                                                sx={{
                                                    backgroundColor: colorConfigs.btn.main.bg
                                                }}
                                                onClick={() => {
                                                    if (currentWebCam === "return-vehicle") {
                                                        if (webRef.current !== null) {
                                                            //@ts-ignore
                                                            const imageSrc = webRef.current.getScreenshot();
                                                            handleCapture(imageSrc, `${baseURL}reservationFile/upload`, tenantId, (imageFilePath: string) => {
                                                                if (imageFilePath) {
                                                                    setReturnVehicleNewFilePath((prevFileString: string[]) => [
                                                                        ...prevFileString,
                                                                        `${baseURL}reservationFile/Get?name=${imageFilePath}`
                                                                    ]);

                                                                    const newFile: any = {
                                                                        id: 0,
                                                                        fileName: `${baseURL}reservationFile/Get?name=${imageFilePath}`
                                                                    };
                                                                    setReturnVehicleFilePath((prevFileString: any[]) => [
                                                                        ...prevFileString,
                                                                        newFile,
                                                                    ]);
                                                                }
                                                            })

                                                            setShowWebcam(false);
                                                        }
                                                    } else if (currentWebCam === "new-vehicle") {
                                                        if (webRef.current !== null) {
                                                            //@ts-ignore
                                                            const imageSrc = webRef.current.getScreenshot();
                                                            handleCapture(imageSrc, `${baseURL}reservationFile/upload`, tenantId, (imageFilePath: string) => {
                                                                if (imageFilePath) {
                                                                    setNewVehicleNewFilePath((prevFileString: string[]) => [
                                                                        ...prevFileString,
                                                                        `${baseURL}reservationFile/Get?name=${imageFilePath}`
                                                                    ]);

                                                                    const newFile: any = {
                                                                        id: 0,
                                                                        fileName: `${baseURL}reservationFile/Get?name=${imageFilePath}`
                                                                    };
                                                                    setNewVehicleFilePath((prevFileString: any[]) => [
                                                                        ...prevFileString,
                                                                        newFile,
                                                                    ]);
                                                                }
                                                            })

                                                            setShowWebcam(false);
                                                        }
                                                    }
                                                }}
                                            >
                                                Capture an Image
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>


            <CustomImagePopup
                showPopup={imagePopup}
                handlePopup={() => setImagePopup(false)}
                filePath={currentPreview === 'return-vehicle' ? returnVehicleFilePath : currentPreview === 'pickup-vehicle' ? pickupVehicleFilePath : newVehicleFilePath}
                fileIndex={currentPreview === 'return-vehicle' ? returnVehiclefileIndex : currentPreview === 'pickup-vehicle' ? pickupVehiclefileIndex : newVehicleFileIndex}
                setFileIndex={currentPreview === 'return-vehicle' ? setReturnVehiclefileIndex : currentPreview === 'pickup-vehicle' ? setPickupVehiclefileIndex : setNewVehicleFileIndex}
                imageBaseUrlPath="reservationFile"
                updateFile={updateFile}
            />
        </>
    )
}

export default EditReplaceVehicleModal;